export const categories = {
  corrective: {
    key: 'corrective',
    label: 'Corrective',
  },
  preventive: {
    key: 'preventive',
    label: 'Preventive',
  },
  onboarding: {
    key: 'onboarding',
    label: 'Onboarding',
  },
  offboarding: {
    key: 'offboarding',
    label: 'Offboarding',
  },
};

export const categoriesList = Object.values(categories);

export const states = {
  open: {
    key: 'open',
    label: 'Open',
  },
  in_progress: {
    key: 'in_progress',
    label: 'In Progress',
  },
  pending_review: {
    key: 'pending_review',
    label: 'Pending Review',
  },
  closed: {
    key: 'closed',
    label: 'Closed',
  },
};

export const statesList = Object.values(states);

export const types = {
  inspection: {
    key: 'inspection',
    label: 'Inspection',
  },
  repair: {
    key: 'repair',
    label: 'Repair',
  },
  maintenance: {
    key: 'maintenance',
    label: 'Maintenance',
  },
};

export const typesList = Object.values(types);

export enum Priority {
  VeryLow = 1,
  Low = 2,
  Medium = 3,
  High = 4,
  Critical = 5,
}

export const priorities = {
  [Priority.VeryLow]: {
    value: Priority.VeryLow,
    key: 'very_low',
    label: 'Very Low',
  },
  [Priority.Low]: {
    value: Priority.Low,
    key: 'low',
    label: 'Low',
  },
  [Priority.Medium]: {
    value: Priority.Medium,
    key: 'medium',
    label: 'Medium',
  },
  [Priority.High]: {
    value: Priority.High,
    key: 'high',
    label: 'High',
  },
  [Priority.Critical]: {
    value: Priority.Critical,
    key: 'critical',
    label: 'Critical',
  },
};

export const prioritiesList = Object.values(priorities);

export enum Impact {
  High = 1,
  Medium = 2,
  Low = 3,
}

export const impacts = {
  [Impact.High]: {
    value: Impact.High,
    key: 'high',
    label: 'High',
  },
  [Impact.Medium]: {
    value: Impact.Medium,
    key: 'medium',
    label: 'Medium',
  },
  [Impact.Low]: {
    value: Impact.Low,
    key: 'low',
    label: 'Low',
  },
};

export const impactsList = Object.values(impacts);
